import { Theme, Typography, withStyles } from '@material-ui/core';
import { Button } from 'bc-front-sagacomponents';
import React, { useState } from 'react';
import Layout from '../../components/Layout';
import IllustrationNotFoundSvg from '../../images/illustration-notfound';
import history from '../../services/history';
import styles from './style';

interface Props {
  classes?: any;
}
const NotFoundPage = (props: Props) => {
  const { classes } = props;

  const [theme, setTheme] = useState<Theme>();
  return (
    <Layout passTheme={setTheme}>
      <div className={classes.containerNotFound}>
        <div className={classes.container}>
          <div className={classes.title}>
            <Typography variant="h2">
              Cette page n’existe <strong>pas ou plus</strong>
            </Typography>
          </div>
          <Typography variant="h4">
            Nous vous prions de nous excuser pour la gêne occasionnée
            <br /> Nous vous invitions à revenir à la page d’accueil de notre site.
          </Typography>
          <Button title="Retour à l'accueil" onClick={() => history.push('/')} variant="contained" color="primary" />
        </div>
        <div className={classes.illu}>
          <IllustrationNotFoundSvg
            color1={theme ? theme.palette.secondary.main : ''}
            color2={theme ? theme.palette.secondary.light : ''}
          ></IllustrationNotFoundSvg>
        </div>
      </div>
    </Layout>
  );
};

export default withStyles(styles)(NotFoundPage);
